/* unplugin-vue-components disabled */import { render } from "./beyondWarn.vue?vue&type=template&id=2e3b81a0&scoped=true"
import script from "./beyondWarn.vue?vue&type=script&lang=js"
export * from "./beyondWarn.vue?vue&type=script&lang=js"

import "./beyondWarn.vue?vue&type=style&index=0&id=2e3b81a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e3b81a0"]])

export default __exports__